module.exports = __webpack_public_path__ + "img/borders1.d97f87c5.png";